module.exports = __webpack_public_path__ + "img/login.c80bc8d8.svg";